import React, { useEffect, useRef, useState } from 'react';
import { BOARD_CHAT_LAYOUTS } from '../utils/boardChatLayout';

function IconModal({ active }) {
  return (
    <svg width="40" height="28" viewBox="0 0 40 28" fill="none" aria-hidden="true">
      <rect x="1" y="1" width="38" height="26" rx="3" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="6.5" cy="6.5" r="1.2" fill={active ? '#a78bfa' : '#f87171'} />
      <circle cx="10.5" cy="6.5" r="1.2" fill={active ? '#c4b5fd' : '#fbbf24'} />
      <circle cx="14.5" cy="6.5" r="1.2" fill={active ? '#ddd6fe' : '#4ade80'} />
      <rect x="10" y="10" width="20" height="12" rx="1.5" fill="currentColor" opacity="0.28" />
    </svg>
  );
}

function IconFullscreen() {
  return (
    <svg width="40" height="28" viewBox="0 0 40 28" fill="none" aria-hidden="true">
      <rect x="1" y="1" width="38" height="26" rx="3" stroke="currentColor" strokeWidth="1.4" />
      <rect x="4" y="8" width="32" height="16" rx="1.5" fill="currentColor" opacity="0.28" />
    </svg>
  );
}

function IconSidebar() {
  return (
    <svg width="40" height="28" viewBox="0 0 40 28" fill="none" aria-hidden="true">
      <rect x="1" y="1" width="38" height="26" rx="3" stroke="currentColor" strokeWidth="1.4" />
      <rect x="26" y="4" width="10" height="20" rx="1.5" fill="currentColor" opacity="0.28" />
    </svg>
  );
}

const OPTIONS = [
  { id: BOARD_CHAT_LAYOUTS.modal, label: 'Modal', Icon: IconModal },
  { id: BOARD_CHAT_LAYOUTS.fullscreen, label: 'Tela cheia', Icon: IconFullscreen },
  { id: BOARD_CHAT_LAYOUTS.sidebar, label: 'Barra lateral', Icon: IconSidebar },
];

/** Seletor de layout estilo ClickUp — Modal / Tela cheia / Barra lateral. */
export function BoardChatLayoutSwitcher({ layout, onChange, tipProps }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const layoutTip = tipProps && !open ? tipProps('Alternar layout') : {};

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (!rootRef.current?.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="bch-layout-switcher" ref={rootRef}>
      <button
        type="button"
        className={`bch-layout-trigger${open ? ' is-open' : ''}`}
        aria-label="Alternar layout"
        aria-expanded={open}
        {...layoutTip}
        onClick={() => setOpen((v) => !v)}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <rect x="1.5" y="2" width="13" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
          <path d="M11 2.5v11" stroke="currentColor" strokeWidth="1.4" />
        </svg>
      </button>
      {open ? (
        <div className="bch-layout-menu" role="menu" aria-label="Layout do chat">
          {OPTIONS.map(({ id, label, Icon }) => {
            const active = layout === id;
            return (
              <button
                key={id}
                type="button"
                role="menuitemradio"
                aria-checked={active}
                className={`bch-layout-option${active ? ' is-active' : ''}`}
                onClick={() => {
                  onChange?.(id);
                  setOpen(false);
                }}
              >
                <span className="bch-layout-option-icon">
                  <Icon active={active} />
                </span>
                <span className="bch-layout-option-label">{label}</span>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
